export const GET_BATTLE_DETAIL = 'GET_BATTLE_DETAIL';
export const GET_BATTLE_DETAIL_SUCCESS = 'GET_BATTLE_DETAIL_SUCCESS';
export const GET_BATTLE_DETAIL_FAILURE = 'GET_BATTLE_DETAIL_FAILURE';
export const SAW_BATTLE_DETAIL = 'SAW_BATTLE_DETAIL';
